import { EnumUtils } from '../../../utils/enum.utils';
import { INTEGRATION_TYPES } from '../../common/constants';

export interface IntegrationsMarketplaceGridInstalledWebComponentSchema {
  // all the data needed for rendering
}

export const DEFAULT_ITEMS_PER_PAGE = 4;
export const DEFAULT_NUMBER_OF_COLUMNS = 2;

export enum IntegrationInstancesMethods {
  READ_RECORDS = 'readRecords',
  DELETE_RECORDS = 'deleteRecords',
  MANAGE_RECORD = 'handleAction',
  GET_AVAILABLE_INTEGRATION_INSTANCES = 'getAvailableIntegrationInstances',
}

export enum IntegrationActionContext {
  Create = 'create',
  Edit = 'edit',
  Start = 'enable',
  Stop = 'disable',
  Resync = 'resync',
  Delete = 'delete',
}

export namespace IntegrationActionContext {
  export function getAllContexts(): IntegrationActionContext[] {
    return EnumUtils.GetValues<IntegrationActionContext>(IntegrationActionContext);
  }

  export function isValid(context: null | string): boolean {
    if (context === null) {
      return false;
    }

    return getAllContexts().includes(context as IntegrationActionContext);
  }
}
export enum IntegrationTypes {
  Vcenter = 1,
  // Veeam = 'veeam',
  ContainerImageScanner = INTEGRATION_TYPES.INTEGRATION_TYPE_CONTAINER_IMAGE_SCANNER,
}
